import { React, useState, useEffect } from "react";
import request from "../../../Helpers/API";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { TextField } from "@mui/material";

export const ComentariosModal = ({ open, onClose, folio }) => {
    const [datafiltro, setDatafiltro] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [state, setState] = useState({
        comentario: "",
    });


    useEffect(() => {
        if(!folio)
            return
        onExecute();
    }, [open]);

    const onExecute = () => {
        setLoader({ ...loader, mostrar: true });

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`CotizacionVentas/GetComentarios?folio=${folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setDatafiltro(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };


    const onGuardar = () => {
        if (state.comentario === "") {
            Swal.fire("COTIZACIONES", "Favor de agregar el comentario para la cotizacion", "info");
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `CotizacionVentas/GuardarComentario?folio=${folio}&comentario=${state.comentario}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire({
                    title: "COTIZACIONES",
                    text: "Comentario registrado con exito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setDatafiltro(result);
                setState({
                    comentario: ""
                });
                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("COTIZACIONES", JSON.stringify(error), "error");
                return;
            });
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="comentarios-cotizaciones-modal-formulario">
                    <div className="comentarios-cotizaciones-modal-plantilla">
                        <div
                            className="plantilla-screen-filtro-container"
                            id="mdlFiltros-modal"
                        >
                            <PlantillaScreen
                                titulo={"COMENTARIOS COTIZACION"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>
                                    X
                                </div>
                                <div className={`comentarios-cotizaciones-modal`}>
                                    <div className="comentarios-cotizaciones-modal-container">
                                        <div className="listado-precios-usados-buscador-container">
                                            <div className="listado-clientes-gestionar-header-control">
                                                <TextField
                                                    color="success"
                                                    fullWidth
                                                    multiline
                                                    rows={3}
                                                    value={state.comentario}
                                                    onChange={({ target }) =>
                                                        setState({ ...state, comentario: target.value })
                                                    }
                                                    placeholder="Comentario"
                                                />
                                                <div
                                                    className="btn-serviciomdlguardar"
                                                    onClick={() => onGuardar()}
                                                >
                                                    Guardar
                                                </div>
                                            </div>
                                        </div>
                                        <div className="comentarios-cotizaciones-modal-container-table scroll-4">
                                            <table cellPadding={0} cellSpacing={0}>
                                                <thead>
                                                    <tr>
                                                        <th>Numero</th>
                                                        <th>
                                                            <div>Comentario</div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datafiltro.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.orden}</td>
                                                            <td>
                                                                {item.comentario}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
